<template lang="html">



    <v-card class="trip-messages-card" elevation="5" style="border: 0px solid rgba(0, 0, 0);" >

        <v-dialog v-model="notifsReaddialog"  max-width="300px">
            <v-card v-if="notificationForDialogData != null">
                <v-card-title primary-title style="background-color: #1976d2">
                    <h3 style="color: white"
                        class="headline mb-0">Notification Read Status</h3>
                </v-card-title>
                <v-divider></v-divider>

                <v-tabs grow
                        key="1"
                        color="#1976d2"
                        dark
                        slider-color="white"
                >
                    <v-tab key="1" ripple>
                        <v-icon style="margin-right: 10px">fas fa-eye</v-icon>
                        Read ({{notificationForDialogData.readCount}})</v-tab>
                    <v-tab key="2" ripple><v-icon style="margin-right: 10px">fas fa-eye-slash</v-icon>
                        Unread ({{notificationForDialogData.unreadCount}})</v-tab>


                    <v-tab-item  key="1">
                        <v-card flat>
                            <v-card-text style="height: 300px;">
                                <v-list subheader>
                                    <template v-for="status in notificationForDialogData.readStatuses"   >
                                        <v-list-tile v-if="status.read"
                                        >
                                            <v-list-tile-content  >
                                                <v-list-tile-title>{{status.user.firstName + ' ' + status.user.lastName}}</v-list-tile-title>
                                                <v-list-tile-sub-title>Read</v-list-tile-sub-title>
                                            </v-list-tile-content>

                                        </v-list-tile>
                                    </template>

                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item  key="2">
                        <v-card flat>
                            <v-card-text style="height: 300px;">
                                <v-list subheader>
                                    <template  v-for="status in notificationForDialogData.readStatuses">
                                        <v-list-tile  v-if="!status.read"
                                        >
                                            <v-list-tile-content >
                                                <v-list-tile-title>{{status.user.firstName + ' ' + status.user.lastName}}</v-list-tile-title>
                                                <v-list-tile-sub-title>Unread</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>

                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>



            </v-card>
        </v-dialog>

    <v-tabs v-bind:class="{ hideTabs: forceHistory }"
            centered
            fixed-tabs
            v-model="selectedTab"
            color="transparent"

    >
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab  key="1">
        <v-icon>add</v-icon>
      </v-tab>

      <v-tab key="2">
        <v-icon>history</v-icon>
      </v-tab>


      <v-tab-item
              :key="1"
      >
          <v-card-title primary-title>
            <v-flex xs12 text-xs-center v-if="selectedUser == null">
              <h3 class="headline mb-0">Send Update</h3>
              <div >Notify travelers registered for trip</div>

            </v-flex>
              <v-flex xs12 text-xs-center v-else>
                  <h3 class="headline mb-0">Send Message</h3>
                  <div >Notify parent user of this participant</div>

              </v-flex>

          </v-card-title>

          <v-container style="border-top: lightgray 1px solid;">

            <div>
              <v-textarea
                      name="input-7-1" no-resize row-height="20" rows="2"
                      label="Update Title*"
                      hide-details
                      v-model="updateData.title"
              ></v-textarea>

              <v-textarea
                      name="input-7-1" no-resize row-height="20" rows="4"
                      label="Update Body"
                      v-model="updateData.message"
                      hide-details
              ></v-textarea>
              <v-checkbox v-if="selectedUser == null"
                      label="Send Notification Emails"
                      v-model="updateData.email"
                      hide-details
                      height="10px"
              ></v-checkbox>

            </div>


          </v-container>



          <v-card-actions>
            <v-layout row wrap>
              <v-flex

                      pa-1  style="border-top: lightgray 1px solid;">

                <v-btn @click="PostUpdate()" color="primary">Post Update</v-btn>
              </v-flex>
            </v-layout>

          </v-card-actions>

      </v-tab-item>


      <v-tab-item
              :key="2"
      >
          <v-card-title primary-title>
            <v-flex xs12 text-xs-center v-if="selectedUser == null">
              <h3 class="headline mb-0">Track Trip Updates</h3>
              <div>The most recent changes to trips you registered for</div>

            </v-flex>
              <v-flex xs12 text-xs-center v-else>
                  <h3 class="headline mb-0">User Messages</h3>
                  <div>The most recent direct messages to user</div>

              </v-flex>


          </v-card-title>

          <v-container style="border-top: lightgray 1px solid;">

            <v-timeline style="padding-top: 0px;"
            <v-timeline style="padding-top: 0px;"
                    dense
            >



              <v-timeline-item v-for="notification in $structuredData.notifications" v-if="(selectedUser == null && notification.user == null) || notification.user == selectedUser "
                               color="primary"
                               small
              >
                <template v-show="selectedTrip != null" v-slot="opposite" v-if="selectedTrip == null">
                    <v-flex  class="text-xs-left">

                        <h4>{{notification.tripName}}</h4>
                         <span
                                v-text="notification.dateFormatted"
                        ></span>


                        <v-divider></v-divider>
                    </v-flex>

                </template>
                <v-layout pt-0>
                  <v-flex >
                    <v-card>

                      <v-container style="padding: 10px;" background="secondary" dark>
                        <h4> {{notification.title}}  </h4>
                      <v-btn v-if="(selectedUser == null && ($userData.permissions[0]=='admin'  || $userData.permissions[0]=='sales'|| $userData.permissions[0]=='director'))" @click="openNotifsDialog(notification)"  dark small color="primary">
                          Read Status</v-btn>
                          <span  v-else  style="position: absolute; top: 0px; left: 0px;">
                              <v-chip dark color="primary"  v-if="notification.readCount > 0" small>
                              Read
                          </v-chip>
                              <v-chip v-else>
                                  Unread
                              </v-chip>
                          </span>

                      </v-container>
                      <v-container style="padding: 10px; border-top: lightgray 1px solid;">

                        <span>{{notification.message}}</span>
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>

              </v-timeline-item>



            </v-timeline>


          </v-container>




      </v-tab-item>

    </v-tabs>

    </v-card>


</template>

<script lang="js">
  export default  {
    name: 'trip-messages',
    props: ["showCreate", "fullPage", "selectedTrip", "selectedUser"],
    mounted() {

    },
    data() {
      return {
          selectedTab: 1,
          updateData: {
              "message" :'',
              "title": '',
              "email": false
          },
          notifsReaddialog: false,
          notificationForDialogData : null
      }
    },
    methods: {
        openNotifsDialog(notif) {
            this.notificationForDialogData = notif
            this.notifsReaddialog = true
        },
        PostUpdate() {

            if(this.selectedUser == null) {
              console.log('add notif for NOT specific user')
                this.updateData.date = new Date()
                this.updateData.trip = this.selectedTrip._id
                this.$services.notifications.create(this.updateData).then((result) => {
                    console.log('send notif', result)
                    this.$addNotification(result)
                    this.selectedTab = 1
                    this.updateData = {
                        "message" :'',
                        "title": '',
                        "email": false
                    }
                })

            } else { // specific user

              console.log('add notif for a specific user')

                this.updateData.date = new Date()
                this.updateData.user = this.selectedUser
                this.updateData.email = true
                this.$services.notifications.create(this.updateData).then((result) => {
                    console.log('send notif', result)
                    this.$addNotification(result)
                    this.selectedTab = 1
                    this.updateData = {
                        "message" :'',
                        "title": '',
                        "email": false
                    }
                })

            }


        }

    },
    computed: {
        forceHistory(){
            if(!this.showCreate || (this.selectedTrip == null && this.selectedUser == null)) {
                this.selectedTab = 1
                return true
            } else {
                return false
            }
        }

    }
}
</script>

<style lang="scss">
  .trip-messages-card .hideTabs .v-tabs__bar{
    display: none !important;
  }
</style>
